import { SortCriteria } from "../models";

//allows sort on multiple columns
export function sort<T>(list: T[], sortCriteriaList: Partial<SortCriteria>[]): T[] {
  if (!list) { return list;}
  let sortedList: T[] = [];
  if (!sortCriteriaList || sortCriteriaList.length == 0) {
    sortedList = [...list];
  }
  else {
    sortedList = [...list].sort(fieldSorter(sortCriteriaList));
  }

  return sortedList;
}

const fieldSorter = (fields: Partial<SortCriteria>[]) => (a, b) => fields.map((sortCriteria: SortCriteria) => {
  //const res = compare(a[sortCriteria.column], b[sortCriteria.column]);
  const res = compare(resolvePath(a, sortCriteria.column, null), resolvePath(b, sortCriteria.column, null));
  return sortCriteria.direction === 'asc' ? res : -res;
}).reduce((p, n) => p ? p : n, 0);

const compare = (v1: string | number | Date, v2: string | number | Date) => {
  if (typeof v1 == "string" && typeof v2 == "string") { v1 = v1.toLowerCase(); v2 = v2.toLowerCase(); }
  else if (typeof v1 == "boolean") {
  }
  if (v1 === null && v2 !== null) {
    return -1;
  }
  else if (v2 === null && v1 !== null) {
    return 1;
  }
  else if (v1 === null && v2 === null) {
    return 0;
  }
  return v1 < v2 ? -1 : v1 > v2 ? 1 : 0;
}

const resolvePath = (object, path, defaultValue) => {
  if (!path) return defaultValue;

  return path
    .split('.')
    .reduce((o, p) => o ? o[p] : defaultValue, object)
}
